export const products29 = [
  {
    id: 352,
    imgSrc: "/assets/images/home/demo14/product-1.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 353,
    imgSrc: "/assets/images/home/demo14/product-2.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 354,
    imgSrc: "/assets/images/home/demo14/product-3.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 355,
    imgSrc: "/assets/images/home/demo14/product-4.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 356,
    imgSrc: "/assets/images/home/demo14/product-5.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 357,
    imgSrc: "/assets/images/home/demo14/product-1.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 358,
    imgSrc: "/assets/images/home/demo14/product-2.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 359,
    imgSrc: "/assets/images/home/demo14/product-3.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 360,
    imgSrc: "/assets/images/home/demo14/product-4.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
  {
    id: 361,
    imgSrc: "/assets/images/home/demo14/product-5.jpg",
    category: "hospital equipment",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    available: 6,
    sold: 28,
    percentage: Math.round((28 / (6 + 28)) * 100),
  },
];

export const products30 = [
  {
    id: 362,
    imgSrc: "/assets/images/home/demo14/product-6.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 363,
    imgSrc: "/assets/images/home/demo14/product-7.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 364,
    imgSrc: "/assets/images/home/demo14/product-8.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 365,
    imgSrc: "/assets/images/home/demo14/product-9.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 366,
    imgSrc: "/assets/images/home/demo14/product-10.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 367,
    imgSrc: "/assets/images/home/demo14/product-7.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 368,
    imgSrc: "/assets/images/home/demo14/product-10.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 369,
    imgSrc: "/assets/images/home/demo14/product-6.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 370,
    imgSrc: "/assets/images/home/demo14/product-9.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 371,
    imgSrc: "/assets/images/home/demo14/product-8.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 372,
    imgSrc: "/assets/images/home/demo14/product-9.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 373,
    imgSrc: "/assets/images/home/demo14/product-7.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 374,
    imgSrc: "/assets/images/home/demo14/product-10.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 375,
    imgSrc: "/assets/images/home/demo14/product-6.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 376,
    imgSrc: "/assets/images/home/demo14/product-8.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 377,
    imgSrc: "/assets/images/home/demo14/product-6.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 378,
    imgSrc: "/assets/images/home/demo14/product-7.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 379,
    imgSrc: "/assets/images/home/demo14/product-8.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 380,
    imgSrc: "/assets/images/home/demo14/product-9.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 381,
    imgSrc: "/assets/images/home/demo14/product-10.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Featured",
  },
  {
    id: 382,
    imgSrc: "/assets/images/home/demo14/product-7.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 383,
    imgSrc: "/assets/images/home/demo14/product-10.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 384,
    imgSrc: "/assets/images/home/demo14/product-6.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 385,
    imgSrc: "/assets/images/home/demo14/product-9.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 386,
    imgSrc: "/assets/images/home/demo14/product-8.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Best Seller",
  },
  {
    id: 387,
    imgSrc: "/assets/images/home/demo14/product-9.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 388,
    imgSrc: "/assets/images/home/demo14/product-7.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 389,
    imgSrc: "/assets/images/home/demo14/product-10.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 390,
    imgSrc: "/assets/images/home/demo14/product-6.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
  {
    id: 391,
    imgSrc: "/assets/images/home/demo14/product-8.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
    filterCategory: "Sales",
  },
];

export const products31 = [
  {
    id: 392,
    imgSrc: "/assets/images/home/demo14/product-11.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 393,
    imgSrc: "/assets/images/home/demo14/product-12.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 394,
    imgSrc: "/assets/images/home/demo14/product-13.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 395,
    imgSrc: "/assets/images/home/demo14/product-14.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 396,
    imgSrc: "/assets/images/home/demo14/product-11.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 397,
    imgSrc: "/assets/images/home/demo14/product-12.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 398,
    imgSrc: "/assets/images/home/demo14/product-13.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 399,
    imgSrc: "/assets/images/home/demo14/product-14.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
];

export const products32 = [
  {
    id: 400,
    imgSrc: "/assets/images/home/demo14/product-15.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 401,
    imgSrc: "/assets/images/home/demo14/product-16.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 402,
    imgSrc: "/assets/images/home/demo14/product-17.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 403,
    imgSrc: "/assets/images/home/demo14/product-18.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 404,
    imgSrc: "/assets/images/home/demo14/product-15.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 405,
    imgSrc: "/assets/images/home/demo14/product-16.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 406,
    imgSrc: "/assets/images/home/demo14/product-17.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
  {
    id: 407,
    imgSrc: "/assets/images/home/demo14/product-18.jpg",
    title: "Anti-Dust Filter, Breathable, 3 Layers of Purifying",
    price: 29,
    category: "hospital equipment",
  },
];
